import { Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormsModule, NgModel, ReactiveFormsModule } from '@angular/forms';
import { NgFor, NgIf } from '@angular/common';
//import { FormDataService } from '../../../Services/Form Data /form-data.service';
import { FormDataService } from '../../../Services/Form Data/form-data.service';
import { DataService } from '../../../Services/Data Service/data.service';
import { AuthService } from '../../../Auth/auth.service';
import { firstValueFrom, forkJoin, switchMap, take } from 'rxjs';
import { FormUpdateService } from '../../../Services/Form Data/formupdate.service';
import { FormSubmitService } from '../../../Services/Form Data/formsubmit.service';
import { DisableAutocompleteDirective } from '../../../disable-autocomplete.directive';

@Component({
  selector: 'app-d-directors-authority-form',
  standalone: true,
  imports: [FormsModule, NgFor, NgIf, DisableAutocompleteDirective],
  templateUrl: './d-directors-authority-form.component.html',
  styleUrl: './d-directors-authority-form.component.css',
  providers: []
})
export class DDirectorsAuthorityFormComponent {
  @Input() isViewOnly: boolean = false;
  @Input() formData: any; 
  
  error_message = '';

  directors: { strName: string; strJobPosition: string }[] = [];
  authsignatories: { strName: string; strJobPosition: string; strEmail: string; strPhoneNumber: string; }[] = [];
  subsidaries: { strName: string; strAddress: string; strAffiliation: string; }[] = [];

  loading = false;
  currUser: any;
  savedMessage = '';
  exists = false;


  constructor(private formDataService: FormDataService, private dataService: DataService, private auth: AuthService, private formSubmitService: FormSubmitService) {
    this.currUser = this.formDataService.getUserData(); 
  }

  ngOnInit(): void {
    // Directors
    const directorsData = this.formDataService.getDirectors();
    console.log('Directors data:', directorsData);
    this.directors = (directorsData && directorsData.length > 0) ? directorsData : [{
      strName: '',
      strJobPosition: ''
    }];

    // Auth Signatories
    const authData = this.formDataService.getAuthSignatories();
    this.authsignatories = (authData && authData.length > 0) ? authData : [{
      strName: '',
      strJobPosition: '',
      strEmail: '',
      strPhoneNumber: ''
    }];
    
    //Subsidaries
    const subs = this.formDataService.getSubsidaries();
    this.subsidaries = (subs && subs.length > 0) ? subs : [{
      strName: '',
      strAddress: '',
      strAffiliation: ''
    }];
  }

  get hasSubsidariesWithName(): boolean {
    return this.subsidaries?.some(s => s.strName?.trim()) ?? false;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['formData']){
      if (this.formData?.directors) {
        this.directors = this.formData.directors.map((d: any) => ({ strName: d.strName, strPosition: d.strPosition,}))
      }
      if (this.formData?.authsignatories) {
        this.authsignatories = this.formData.authsignatories.map((d: any) => ({ 
          strName: d.strName, 
          strPosition: d.strPosition,
          strEmail: d.strEmail,
          strPhone: d.strPhone
        }))
        // console.log("Signatories: ", this.authsignatories)
      }
      if (this.formData?.subsidaries) {
        this.subsidaries = this.formData.subsidaries.map((d: any) => ({ 
          strName: d.strName, 
          strAddress: d.strAddress,
          strAffiliation: d.strAffiliation,
        }))
      }
    }
  }
  

  //Add Rows
  addDirectorRow(){
    this.directors.push({ strName: '', strJobPosition: '' });
  }

  addAuthRow(){
    this.authsignatories.push({ strName: '', strJobPosition: '', strEmail: '', strPhoneNumber: '+1868'});
  }

  addAffilRow(){
    this.subsidaries.push({ strName: '', strAddress: '', strAffiliation: ''});
  }

  //Delete Rows
  removeDirector(index: number) {
    this.directors.splice(index, 1);
  }
  
  removeAuthRow(index: number) {
    this.authsignatories.splice(index, 1);
  }
  
  removeAffilRow(index: number) {
    this.subsidaries.splice(index, 1);
  }
  
  validateEmail(email: string): void {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValid = emailPattern.test(email);

    if (!isValid) {
      this.error_message = "Invalid email format. Please enter a valid email.";
    } else {
      this.error_message = "";
    }
  }


  validatePhoneNumber(input: string): void {
    // Remove all spaces
    const formattedInput = input.replace(/\s+/g, '');
  
    // Regular expression to match area code (3 digits) + 7 digits = 10 digits total
    const phonePattern = /^\d{10}$/;
  
    if (!phonePattern.test(formattedInput)) {
      this.error_message = "Phone number must be 10 digits (area code + 7 digits).";
      return;
    }
  
    this.error_message = "";
  }


  validatefields(): boolean {
    console.log("Directors: ", this.directors);
    console.log("Authorized Signatories: ", this.authsignatories);
    console.log("Subsidaries: ", this.subsidaries);

    if (!this.directors.length || this.directors.every(director => !director.strName.trim() && !director.strJobPosition.trim())) {
      this.error_message = 'Please enter at least one director.';
      return false;
    }
    
    if (this.directors.some(director => !director.strName.trim() || !director.strJobPosition.trim())) {
      this.error_message = 'All director rows must be fully completed.';
      return false;
    }
    
    if (!this.authsignatories.length || this.authsignatories.every(auth => !auth.strName.trim() && !auth.strJobPosition.trim() && !auth.strEmail.trim() && !auth.strPhoneNumber.trim())) {
      this.error_message = 'Please enter at least one authorised person.';
      return false;
    }
    
    if (this.authsignatories.some(auth => !auth.strName.trim() || !auth.strJobPosition.trim() || !auth.strEmail.trim() || !auth.strPhoneNumber.trim())) {
      this.error_message = 'All authorised signatory rows must be fully completed.';
      return false;
    }
    
    if (this.authsignatories.some(auth => !auth.strPhoneNumber?.trim())) { //phone number was never changed and validator not reached
      this.error_message = "Please enter a valid phone number.";
      return false;
    }

    if (this.subsidaries[0].strName && this.subsidaries.some(subs => !subs.strName.trim() || !subs.strAddress.trim() || !subs.strAffiliation.trim())) {
      this.error_message = 'All affiliated company rows must be fully completed.';
      return false;
    }
    
    return true;
  }

  resetErrorMessage(){
    this.error_message = '';
  }

  async onSubmit(): Promise<boolean>{
    if (!this.validatefields()) {
     return false; // Validation failed
    }
    if (this.error_message !== "") {
      return false; // Error message present, do not proceed
    }

    this.loading = true;
    this.error_message = "";

    //update Local formData 
    this.formDataService.updateDirectors( this.directors );
    this.formDataService.updateAuthSignatories( this.authsignatories );
    this.formDataService.updateSubsidaries( this.subsidaries );

    //SAVE directors, signatories and subsidaries TO DB
    try {
      await firstValueFrom( forkJoin([
      this.formSubmitService.submitDirector(this.formDataService.getCurrCompanyID()),
      this.formSubmitService.submitSignatories(this.formDataService.getCurrCompanyID()),
      this.formSubmitService.submitSubsidaries(this.formDataService.getCurrCompanyID())
    ]));
      this.loading = false;
      return true;
    } catch (error) {
      this.error_message = "There was an issue saving. Please try again.";
      this.loading = false;
      return false;
    }
  }
}
